module.exports = __webpack_public_path__ + "img/retrofit-details-3.b281a30c.png";